import Button, {ButtonProps} from '@mui/material/Button';

import {getEmpionButtonStyle, type EmpionButtonVariant} from './styles/getEmpionButtonStyle';

type Props = Omit<ButtonProps, 'variant'> & {
  variant?: EmpionButtonVariant;
  to?: string;
  disabledColor?: string;
  textColor?: string;
  hoverTextColor?: string;
  hoverBackgroundColor?: string;
};

const resolveVariant = (variant: Props['variant']): ButtonProps['variant'] => {
  if (variant === 'secondary') {
    return 'outlined';
  }
  if (variant === 'menu') {
    return 'text';
  }
  if (variant !== 'primary' && variant !== 'cta' && variant !== 'warning') {
    return variant;
  }
  return 'contained';
};

export const EmpionButton = (props: Props) => {
  const {disabledColor, textColor, hoverTextColor, hoverBackgroundColor, variant = 'primary', ...rest} = props;
  const resolvedVariant = resolveVariant(variant);
  const buttonSx = getEmpionButtonStyle({
    resolvedVariant,
    variant,
    color: props.color,
    disabledColor,
    textColor,
    hoverTextColor,
    hoverBackgroundColor,
  });

  const sizeSx = props.size === 'small' ? {fontSize: 13} : {};

  return (
    <Button
      {...rest}
      color={props.color || 'secondary'}
      variant={resolvedVariant}
      sx={{
        ...buttonSx,
        ...sizeSx,
        ...props.sx,
      }}
    >
      {props.children}
    </Button>
  );
};
